module.exports = __webpack_public_path__ + "static/media/Inter-Italic.dfadecc8.woff2";